import React, { createContext, useContext, useState, useCallback } from 'react';

interface DropcartContextType {
  isOpen: boolean;
  openDropcart: () => void;
  closeDropcart: () => void;
  toggleDropcart: () => void;
}

const DropcartContext = createContext<DropcartContextType | undefined>(undefined);

export const DropcartProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openDropcart = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeDropcart = useCallback(() => {
    setIsOpen(false);
  }, []);

  const toggleDropcart = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  return (
    <DropcartContext.Provider
      value={{
        isOpen,
        openDropcart,
        closeDropcart,
        toggleDropcart,
      }}
    >
      {children}
    </DropcartContext.Provider>
  );
};

export const useDropcart = (): DropcartContextType => {
  const context = useContext(DropcartContext);
  if (!context) {
    throw new Error('useDropcart must be used within a DropcartProvider');
  }
  return context;
};
